/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.8
 * Contact: 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MonitoringTimeStatsDTO
 */
export interface MonitoringTimeStatsDTO {
    /**
     * 
     * @type {number}
     * @memberof MonitoringTimeStatsDTO
     */
    totalMonitoringSeconds: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof MonitoringTimeStatsDTO
     */
    monitoringSecondsPerDay: Array<number>;
}

/**
 * Check if a given object implements the MonitoringTimeStatsDTO interface.
 */
export function instanceOfMonitoringTimeStatsDTO(value: object): value is MonitoringTimeStatsDTO {
    if (!('totalMonitoringSeconds' in value) || value['totalMonitoringSeconds'] === undefined) return false;
    if (!('monitoringSecondsPerDay' in value) || value['monitoringSecondsPerDay'] === undefined) return false;
    return true;
}

export function MonitoringTimeStatsDTOFromJSON(json: any): MonitoringTimeStatsDTO {
    return MonitoringTimeStatsDTOFromJSONTyped(json, false);
}

export function MonitoringTimeStatsDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): MonitoringTimeStatsDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'totalMonitoringSeconds': json['totalMonitoringSeconds'],
        'monitoringSecondsPerDay': json['monitoringSecondsPerDay'],
    };
}

export function MonitoringTimeStatsDTOToJSON(value?: MonitoringTimeStatsDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'totalMonitoringSeconds': value['totalMonitoringSeconds'],
        'monitoringSecondsPerDay': value['monitoringSecondsPerDay'],
    };
}

